__turbopack_context__.v({
  "bot": "Chatbot-module__XNtYyW__bot",
  "chat-blink": "Chatbot-module__XNtYyW__chat-blink",
  "chat-in": "Chatbot-module__XNtYyW__chat-in",
  "chat-out": "Chatbot-module__XNtYyW__chat-out",
  "chip": "Chatbot-module__XNtYyW__chip",
  "chips": "Chatbot-module__XNtYyW__chips",
  "composer": "Chatbot-module__XNtYyW__composer",
  "count": "Chatbot-module__XNtYyW__count",
  "countOver": "Chatbot-module__XNtYyW__countOver",
  "dot": "Chatbot-module__XNtYyW__dot",
  "field": "Chatbot-module__XNtYyW__field",
  "gate": "Chatbot-module__XNtYyW__gate",
  "gateActions": "Chatbot-module__XNtYyW__gateActions",
  "gateBody": "Chatbot-module__XNtYyW__gateBody",
  "gateError": "Chatbot-module__XNtYyW__gateError",
  "gateField": "Chatbot-module__XNtYyW__gateField",
  "gateInput": "Chatbot-module__XNtYyW__gateInput",
  "gateLabel": "Chatbot-module__XNtYyW__gateLabel",
  "gateLink": "Chatbot-module__XNtYyW__gateLink",
  "gatePrimary": "Chatbot-module__XNtYyW__gatePrimary",
  "gateRow": "Chatbot-module__XNtYyW__gateRow",
  "gateTile": "Chatbot-module__XNtYyW__gateTile",
  "gateTileQuiet": "Chatbot-module__XNtYyW__gateTileQuiet",
  "gateTitle": "Chatbot-module__XNtYyW__gateTitle",
  "head": "Chatbot-module__XNtYyW__head",
  "headText": "Chatbot-module__XNtYyW__headText",
  "iconBtn": "Chatbot-module__XNtYyW__iconBtn",
  "launcher": "Chatbot-module__XNtYyW__launcher",
  "log": "Chatbot-module__XNtYyW__log",
  "mark": "Chatbot-module__XNtYyW__mark",
  "panel": "Chatbot-module__XNtYyW__panel",
  "panelOut": "Chatbot-module__XNtYyW__panelOut",
  "pill": "Chatbot-module__XNtYyW__pill",
  "root": "Chatbot-module__XNtYyW__root",
  "send": "Chatbot-module__XNtYyW__send",
  "source": "Chatbot-module__XNtYyW__source",
  "sources": "Chatbot-module__XNtYyW__sources",
  "sourcesLabel": "Chatbot-module__XNtYyW__sourcesLabel",
  "sr": "Chatbot-module__XNtYyW__sr",
  "subtitle": "Chatbot-module__XNtYyW__subtitle",
  "title": "Chatbot-module__XNtYyW__title",
  "typing": "Chatbot-module__XNtYyW__typing",
  "user": "Chatbot-module__XNtYyW__user",
});
